export function buttonize(fn: (...args: any[]) => any) {
  return {
    role: 'button',
    onClick: fn,
    onKeyDown: (e) => {
      if (e.key === 'Enter') {
        fn(e);
      }
    },
  };
}
